import {
  Calendar,
  CircleUser,
  type LucideIcon,
  MessageSquare,
  MessagesSquare,
  Plus,
  UserPlus,
  UserStar,
} from 'lucide-react';

/**
 * The lucide names the dispatch dashboard sends with its shortcuts
 * (`DashboardQuickAction.webIcon`), mapped to the icons this bundle carries.
 *
 * The HOST decides what its shortcuts are; this table only decides how one is
 * drawn. So a name missing here falls back to [Plus] rather than to nothing —
 * a shortcut added to the dashboard before the console that draws it has
 * shipped must still be on screen, or the console becomes the thing that makes
 * it disappear.
 */
const HOST_ICONS: Record<string, LucideIcon> = {
  'user-plus': UserPlus,
  'user-star': UserStar,
  'circle-user': CircleUser,
  'message-square': MessageSquare,
  'messages-square': MessagesSquare,
  calendar: Calendar,
};

export const FALLBACK_HOST_ICON: LucideIcon = Plus;

export const hostIcon = (name: string | null | undefined): LucideIcon =>
  (name && Object.hasOwn(HOST_ICONS, name) ? HOST_ICONS[name] : undefined) ?? FALLBACK_HOST_ICON;

/** Every name the table knows — for the test that pins it to the host's list. */
export const KNOWN_HOST_ICONS: readonly string[] = Object.keys(HOST_ICONS);
